<script>
import PageHeader from "@/components/page-header.vue";
import add from "@/views/pages/Dilfoods/options_groups/options/add.vue";
import Layout from "@/views/layouts/main.vue";
import axios from "axios";
import { OpsPath, ItemPath } from "@/path";
import op_up_push from "@/views/pages/Dilfoods/options_groups/options/op_up_push.vue";
import Gravies from "./gravies.vue";
import Packagings from "./packagings.vue";
import RP_Pricing from "./rp_pricing.vue";
import EditIcon from "@/views/pages/Dilfoods/Common/icons/EditIcon.vue";
import DeleteIcon from "@/views/pages/Dilfoods/Common/icons/DeleteIcon.vue";
import UploadIcon from "@/views/pages/Dilfoods/Common/icons/UploadIcon.vue";

export default {
  components: {
    op_up_push,
    Layout,
    add,
    PageHeader,
    Gravies,
    Packagings,
    RP_Pricing,
    EditIcon,
    DeleteIcon,
    UploadIcon,
  },
  data() {
    return {
      title: "Modifiers",
      items: [{ text: "List" }, { text: "Modifier", active: true }],
      itemss: [],
      selectedop: null, // for Add / Edit / Upload
      selectionOption: null, // item for taggings modal
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      ops: { data: [], total: 0, per_page: 10, key: 0 },
      fields: ["title", "modifier_groups", "Locations", "actions"],
      key: 0,
      filter: [],
      current_page: 1,
      search: "",
      loadingOps: false,
      openingModal: null, // "gravy" | "packaging" | "rp_pricing" | null
    };
  },
  watch: {
    current_page() {
      this.getOps();
    },
    search() {
      this.getOps();
    },
  },
  mounted() {
    this.getOps();
    this.getitems();
  },
  methods: {
    reload() {
      this.getOps();
    },
    setEdit(v) {
      this.addModifier();
      this.selectedop = v;
      this.key += 1;
    },
    addModifier() {
      this.$bvModal.show("bv-add-options");
    },
    openTaggings(row, type) {
      const item = row.item || row;
      this.selectionOption = {
        id: item.id,
        title: item.title,
        gravies: Array.isArray(item.gravies) ? [...item.gravies] : [],
        packaging: Array.isArray(item.packaging) ? [...item.packaging] : [],
      };
      this.openingModal = type;

      if (type === "gravy") this.$bvModal.show("gravy_tags");
      else if (type === "packaging") this.$bvModal.show("packaging_tags");
      else this.$bvModal.show("rp_pricing");
    },
    uploadToUP(v) {
      this.selectedop = v;
      this.key += 1;
      this.$bvModal.show("bv-upload-op");
    },

    async getOps() {
      try {
        this.loadingOps = true;
        const res = await axios.get(this.base_url + OpsPath.GETOPS, {
          params: { page: this.current_page, search: this.search },
        });
        if (res.data.status) {
          const data = res.data.data || {};
          this.ops = {
            ...data,
            data: Array.isArray(data.data) ? data.data : [],
            key: (this.ops.key || 0) + 1,
          };
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loadingOps = false;
      }
    },

    async getitems() {
      try {
        const res = await axios.get(this.base_url + ItemPath.ALL);
        if (res.data.status) {
          this.itemss = res.data.data || [];
          this.key += 1;
        }
      } catch (e) {
        console.log(e);
      }
    },

    // === Modal events from Gravies.vue ===
    onGraviesUpdated({ optionId, newGravies }) {
      if (this.selectionOption && this.selectionOption.id === optionId) {
        const byKey = new Map(
          this.selectionOption.gravies.map((g) => [
            `${g.op_id}-${g.brand_id}-${g.gravy_id}`,
            g,
          ])
        );
        newGravies.forEach((n) => {
          byKey.set(`${n.op_id}-${n.brand_id}-${n.gravy_id}`, n);
        });
        this.selectionOption.gravies = Array.from(byKey.values());
      }
      this.mergeOpsGravies(optionId, newGravies);
    },

    onGravyDeleted({ optionId, gravyKey }) {
      if (this.selectionOption && this.selectionOption.id === optionId) {
        this.selectionOption.gravies = this.selectionOption.gravies.filter(
          (g) => `${g.op_id}-${g.brand_id}-${g.gravy_id}` !== gravyKey
        );
      }
      const idx = this.ops.data.findIndex((op) => op.id === optionId);
      if (idx !== -1 && Array.isArray(this.ops.data[idx].gravies)) {
        this.ops.data[idx].gravies = this.ops.data[idx].gravies.filter(
          (g) => `${g.op_id}-${g.brand_id}-${g.gravy_id}` !== gravyKey
        );
      }
    },

    mergeOpsGravies(optionId, newGravies) {
      const idx = this.ops.data.findIndex((op) => op.id === optionId);
      if (idx === -1) return;
      const existing = Array.isArray(this.ops.data[idx].gravies)
        ? this.ops.data[idx].gravies
        : [];
      const byKey = new Map(
        existing.map((g) => [`${g.op_id}-${g.brand_id}-${g.gravy_id}`, g])
      );
      newGravies.forEach((n) => {
        byKey.set(`${n.op_id}-${n.brand_id}-${n.gravy_id}`, n);
      });
      this.$set(this.ops.data[idx], "gravies", Array.from(byKey.values()));
    },

    // Optional delete (wire your delete API if needed)
    deleteData(item) {
      console.log("delete requested for", item);
    },

    onModalHidden() {
      this.selectionOption = null;
      this.openingModal = null;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-md-6">
                <b-button
                  @click="addModifier()"
                  class="btn btn-primary mb-10 pb-10"
                >
                  Add Modifiers
                </b-button>

                <!-- Add/Edit -->
                <b-modal
                  id="bv-add-options"
                  title="Add Modifier"
                  hide-footer
                  @hidden="reload"
                >
                  <add
                    @update="reload"
                    :key="key"
                    :selected_op_g="selectedop"
                  ></add>
                </b-modal>

                <!-- Upload -->
                <b-modal
                  id="bv-upload-op"
                  title="Upload to urban piper"
                  hide-footer
                  @hidden="onModalHidden"
                >
                  <op_up_push :key="key" :op="selectedop"></op_up_push>
                </b-modal>

                <!-- Gravies Tagging -->
                <b-modal
                  id="gravy_tags"
                  :title="
                    selectionOption
                      ? 'Gravy Tagging of - ' + selectionOption.title
                      : 'Gravy Tagging'
                  "
                  size="lg"
                  @hidden="onModalHidden"
                >
                  <Gravies
                    v-if="selectionOption"
                    :gravies="selectionOption.gravies"
                    :option="{
                      id: selectionOption.id,
                      title: selectionOption.title,
                    }"
                    @gravies-updated="onGraviesUpdated"
                    @gravy-deleted="onGravyDeleted"
                  />
                </b-modal>

                <!-- Packaging Tagging -->
                <b-modal
                  id="packaging_tags"
                  :title="
                    selectionOption
                      ? 'Packaging Tagging of - ' + selectionOption.title
                      : 'Packaging Tagging'
                  "
                  size="lg"
                  @hidden="onModalHidden"
                >
                  <Packagings
                    v-if="selectionOption"
                    :packaging="selectionOption.packaging"
                    :option="{
                      id: selectionOption.id,
                      title: selectionOption.title,
                    }"
                  />
                </b-modal>

                <!-- RP Pricing -->
                <b-modal
                  id="rp_pricing"
                  size="xl"
                  hide-footer
                  @hidden="onModalHidden"
                >
                  <RP_Pricing v-if="selectionOption" :data="selectionOption" />
                </b-modal>
              </div>
            </div>

            <!-- Search -->
            <div class="table-responsive mb-0">
              <div class="pb-2 float-right w-25">
                <b-row>
                  <b-col sm="12">
                    <b-input-group size="sm">
                      <b-input-group-prepend is-text>
                        <i class="fa fa-search"></i>
                      </b-input-group-prepend>
                      <b-input
                        size="sm"
                        debounce="300"
                        placeholder="Search"
                        v-model="search"
                      ></b-input>
                    </b-input-group>
                  </b-col>
                </b-row>
              </div>

              <!-- Table -->
              <b-table
                :key="ops.key"
                :items="ops.data"
                :fields="fields"
                responsive="sm"
                :filter="filter"
                :current-page="current_page"
                :busy="loadingOps"
                show-empty
                empty-text="No records found"
              >
                <template #table-busy>
                  <div class="text-center my-2">
                    <b-spinner small class="mr-2"></b-spinner> Loading...
                  </div>
                </template>

                <template #cell(title)="row">
                  <div class="font-weight-bold">{{ row.item.title }}</div>

                  <!-- Gravies -->
                  <div
                    style="color: blue; cursor: pointer"
                    @click="openTaggings(row, 'gravy')"
                  >
                    <span class="ml-4">
                      <i
                        style="color: green"
                        class="fa fa-check-circle"
                        v-if="
                          Array.isArray(row.item.gravies) &&
                          new Set(row.item.gravies.map((f) => f.op_id)).size > 0
                        "
                      ></i>
                      <i
                        v-else
                        class="fa fa-exclamation-circle"
                        style="color: #8a8a71"
                      ></i>
                    </span>
                    Gravies Tagged :
                    {{
                      Array.isArray(row.item.gravies)
                        ? new Set(row.item.gravies.map((f) => f.op_id)).size
                        : 0
                    }}
                  </div>

                  <!-- Packaging -->
                  <div
                    style="color: blue; cursor: pointer"
                    @click="openTaggings(row, 'packaging')"
                  >
                    <span class="ml-4">
                      <i
                        style="color: green"
                        class="fa fa-check-circle"
                        v-if="
                          Array.isArray(row.item.packaging) &&
                          new Set(row.item.packaging.map((f) => f.op_id)).size >
                            0
                        "
                      ></i>
                      <i
                        v-else
                        class="fa fa-exclamation-circle"
                        style="color: #8a8a71"
                      ></i>
                    </span>
                    Packagings Tagged :
                    {{
                      Array.isArray(row.item.packaging)
                        ? new Set(row.item.packaging.map((f) => f.op_id)).size
                        : 0
                    }}
                  </div>

                  <!-- RP Pricing -->
                  <div
                    style="color: blue; cursor: pointer"
                    @click="openTaggings(row, 'rp_pricing')"
                  >
                    <span class="ml-4">
                      <i
                        style="color: green"
                        class="fa fa-check-circle"
                        v-if="
                          Array.isArray(row.item.packaging) &&
                          row.item.packaging.length > 0
                        "
                      ></i>
                      <i
                        v-else
                        class="fa fa-exclamation-circle"
                        style="color: #8a8a71"
                      ></i>
                    </span>
                    RP Pricing
                  </div>
                </template>

                <template #cell(modifier_groups)="row">
                  <template v-if="Array.isArray(row.item.opgs)">
                    <b-tag v-for="(o, oi) in row.item.opgs" :key="oi">{{
                      o.title
                    }}</b-tag>
                  </template>
                </template>

                <template #cell(actions)="row">
                  <div style="display: flex; gap: 0px">
                    <div @click="uploadToUP(row.item)">
                      <UploadIcon :title="'Update to urban piper'" />
                    </div>
                    <div @click="setEdit(row.item)">
                      <EditIcon />
                    </div>
                    <div @click="deleteData(row.item)">
                      <DeleteIcon />
                    </div>
                  </div>
                </template>
              </b-table>
            </div>

            <!-- Pagination -->
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      :key="ops.key"
                      v-model="current_page"
                      :total-rows="ops.total || 0"
                      :per-page="ops.per_page || 10"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped></style>
